import { FC } from 'react'

import { Typography } from '@mui/material'
import { appName } from 'constants/app'

export const Logo: FC = () => (
  <div>
    <Typography align="center" gutterBottom variant="h4">
      {appName}
    </Typography>
    <Typography align="center" paragraph variant="subtitle1">
      Админ-панель
    </Typography>
  </div>
)
